<p-table [value]="table.rows" [columns]="table.columns" styleClass="aya-school-table">
  <ng-template pTemplate="header" let-cols>
    <tr>
      <th class="aya-school-table__program-col">Program</th>
      <th class="aya-school-table__course-col">Courses</th>
      <th *ngFor="let col of cols" class="aya-school-table__price-col">{{ col.header }}</th>
      <th class="aya-school-table__additional-col">Additional Information</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-ri="rowIndex" let-cols="columns">
    <tr>
      <!-- Program cell -->
      <td
        *ngIf="row.firstOfProgram"
        [attr.rowspan]="row.programRowspan"
        [ngClass]="'aya-school-table__' + row.programClass"
        class="aya-school-table__program-cell"
      >
        <i class="fas" [ngClass]="row.programIcon"></i> {{ row.programName }}
      </td>

      <!-- Course name -->
      <td [ngClass]="'aya-school-table__' + row.programClass">
        <div *ngFor="let courseName of row.courseNames | lxSortBy">{{ courseName }}</div>
      </td>

      <!-- Price columns -->
      <td *ngFor="let col of cols">{{ table.currency }}{{ row['m' + col.duration] | lxPrice : { defaultValue: '-' } }}</td>

      <!-- Additional info cell -->
      <td *ngIf="ri === 0" [attr.rowspan]="table.rows.length" class="aya-school-table__additional-cell">
        <ng-container *ngTemplateOutlet="additionalInfo; context: { info: table.additionalInformation }"></ng-container>
      </td>
    </tr>
  </ng-template>
</p-table>

<ng-template #additionalInfo let-info="info">
  <div>{{ info?.priceExplanation }}</div>

  <div *ngIf="info?.included?.length">
    <div class="aya-school-table__additional-cell__included"><i class="fas fa-check-circle"></i> What’s Included:</div>
    <ul>
      <li *ngFor="let i of info.included">{{ i }}</li>
    </ul>
  </div>

  <div *ngIf="info?.notIncluded?.length">
    <div class="aya-school-table__additional-cell__not-included"><i class="fas fa-times-circle"></i> What’s Not Included:</div>
    <ul>
      <li *ngFor="let n of info.notIncluded">{{ n }}</li>
    </ul>
  </div>

  <a class="aya-school-table__additional-cell__school-guide" *ngIf="info?.schoolGuideUrl" [href]="info.schoolGuideUrl" target="_blank"> School Guide </a>
</ng-template>
